import { render, staticRenderFns } from "./AddAdvisor.vue?vue&type=template&id=0b7bf1f5&"
import script from "./AddAdvisor.vue?vue&type=script&lang=js&"
export * from "./AddAdvisor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports